import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import { Box, IconButton, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { connectBusinessFlowSx } from "./connectBusinessFlowStyles";
import { colors } from "./ui/colors";

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const SignUpNextButton = ({
  onSubmit = () => {},
  type,
  disabled = false,
  nextViewEntityState,
  previousViewEntityState,
  sx,
  currentView,
  initialView,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    <div key={"SignUpNextButton"}>
      <Grid
        container
        sx={{
          ...(typeof sx === "object" ? { ...sx } : {}),
          width: "100%",
          mt: 2,
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between", // Empuja los elementos a los extremos
            width: "100%",
          }}
        >
          {/* Lado Izquierdo: Preview */}
          <Box
            onClick={
              typeof previousViewEntityState === "function"
                ? () => {
                    if (currentView === 0) {
                      navigate(initialView);
                    }
                    dispatch(previousViewEntityState());
                  }
                : undefined
            }
            sx={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              color: "text.secondary",
              transition: "0.2s",
              "&:hover": { color: colors.orange.base },
            }}
          >
            <ChevronLeftOutlinedIcon sx={{ fontSize: 20 }} />
            <Typography variant="body2" sx={{ fontWeight: 600, ml: 0.5 }}>
              Preview
            </Typography>
          </Box>

          {/* Lado Derecho: Next */}
          <Button
            type={type}
            disabled={disabled}
            onClick={
              typeof nextViewEntityState === "function"
                ? async () => {
                    try {
                      await onSubmit();
                      if (type === "submit") {
                        if (disabled) {
                          dispatch(nextViewEntityState());
                        }
                      } else {
                        dispatch(nextViewEntityState());
                      }
                    } catch (error) {
                      console.error("Error when trying to execute: onSubmit(); nextViewEntityState()");
                    }
                  }
                : () => {}
            }
            variant="contained"
            disableElevation
            sx={{
              ...connectBusinessFlowSx.primaryButton,
              minWidth: "140px",
              height: 40,
              bgcolor: colors.orange.base,
              color: "white",
              fontWeight: 700,
              textTransform: "none",
              borderRadius: "10px",
              px: 4,
              opacity: disabled ? 0.5 : 1,
              "&:hover": {
                bgcolor: colors.orange[600],
                boxShadow: "none",
              },
              border: "none",
            }}
          >
            Next
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};
